import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { communicationsStakeholderGroupsRoute } from '@atlassian/jira-router-routes-communications-routes/src/communicationsStakeholderGroupsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { stakeholderGroupsPageEntryPoint } from './ui/stakeholder-groups/stakeholderGroupsPageEntryPoint.tsx';

export const communicationsStakeholderGroupsRouteEntry = createEntry(
	communicationsStakeholderGroupsRoute,
	() => ({
		group: 'communications',

		navigation: {
			menuId: MENU_ID.COMMUNICATIONS,
			sidebar: AsyncSidebarServicedesk,
		},

		entryPoint: () => {
			return fg('communications_stakeholder_management_platform')
				? stakeholderGroupsPageEntryPoint
				: undefined;
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-communications-entries/src/communicationsStakeholderGroupsRouteEntry.tsx',
				whichExportToUse: 'communicationsStakeholderGroupsRouteEntry',
			},

			enabled: true,
		},
	}),
);
